import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { Asset, AssetState } from './types';
import { RootState } from '../types';
import tradingService from '../../services/tradingService';
import store from '@/store';
import _ from 'lodash';

const state: AssetState = {
  asset: null,
  errorLoadingAsset: null,
};

const mutations: MutationTree<AssetState> = {
  SET_ASSET(state: AssetState, asset: Asset) {
    state.asset = asset;
  },

  SET_ERROR_ASSET(state: AssetState, error: string) {
    state.errorLoadingAsset = error;
  },
};

const getters: GetterTree<AssetState, RootState> = {
  asset: (state: AssetState) => state.asset,
  errorLoadingAsset: (state: AssetState) => state.errorLoadingAsset,
};

const actions: ActionTree<AssetState, RootState> = {
  async fetchAsset({ commit }: { commit: Function }, assetId: string) {
    store.dispatch('appState/startLoader');
    commit('SET_ERROR_ASSET', null);

    try {
      commit('SET_ASSET', undefined);
      const assetResponse = await tradingService.getAssetById(assetId);
      commit('SET_ASSET', assetResponse.data);
      store.dispatch('appState/stopLoader');

      return assetResponse;
    } catch (error) {
      commit('SET_ASSET', undefined);
      store.dispatch('appState/stopLoader');
      commit('SET_ERROR_ASSET', getError(error));

      return null;
    }
  },

  setAsset({ commit }: { commit: Function }, asset: Asset) {
    commit('SET_ASSET', asset);
  },
};

const getError = (error) => {
  return _.get(error, 'response.data.error') || error;
};

export const asset: Module<AssetState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
